(() => {
  const FRAME_SELECTOR = '[data-product-image-frame]';
  const PRIMARY_SELECTOR = '.product-image-primary';

  const finish = (frame, state = 'is-loaded') => {
    frame.classList.remove('is-loading');
    frame.classList.add(state);
  };

  const initializeFrame = (frame) => {
    if (frame.dataset.imageLoaderReady === 'true') return;
    frame.dataset.imageLoaderReady = 'true';

    const image = frame.querySelector(PRIMARY_SELECTOR);
    if (!image) {
      finish(frame);
      return;
    }

    frame.classList.add('is-loading');

    if (image.complete) {
      finish(frame, image.naturalWidth > 0 ? 'is-loaded' : 'is-error');
      return;
    }

    image.addEventListener('load', () => finish(frame), { once: true });
    image.addEventListener('error', () => finish(frame, 'is-error'), { once: true });

    window.setTimeout(() => finish(frame), 8000);
  };

  const initializeProductImages = (root = document) => {
    if (root.matches?.(FRAME_SELECTOR)) initializeFrame(root);
    root.querySelectorAll?.(FRAME_SELECTOR).forEach(initializeFrame);
  };

  initializeProductImages();

  new MutationObserver((mutations) => {
    mutations.forEach((mutation) => {
      mutation.addedNodes.forEach((node) => {
        if (node.nodeType === 1) initializeProductImages(node);
      });
    });
  }).observe(document.documentElement, { childList: true, subtree: true });
})();
